/*
 * @Author: wangweixin
 * @Date: 2017-12-07 17:12:42
 * @Last Modified by: wangweixin
 * @Last Modified time: 2020-04-15 17:29:30
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';

/**
 * 最基本的Button组件，使用时请以此组件为基准
 */
export default function Button({
  type,
  mini,
  radius,
  children,
  width,
  className,
  style = {},
  ...others
}) {
  const classes = classNames(`btn btn-${type}`, className, {
    mini,
    radius
  });

  return (
    <button
      className={classes}
      {...others}
      style={{
        ...style,
        width: isNumber(width) ? width : width + 'px'
      }}
    >
      <div className="btn-animate" />
      <span className="btn-txt">{children}</span>
    </button>
  );
}
Button.displayName = 'Button';

Button.defaultProps = {
  type: 'primary',
  mini: false,
  radius: true
};

Button.propTypes = {
  /** 按钮类型：默认类型, primary, return, secondary, reset, link, text, white, dark, danger */
  type: PropTypes.string,
  /** 是否是小型按钮 */
  mini: PropTypes.bool,
  /** 是否带圆角 */
  radius: PropTypes.bool,
  /** 支持直接传宽度属性, 传200这样的，不要带单位 */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** 样式 */
  style: PropTypes.object
};
